export const ERROR_MESSAGE = {
  SOMETHING_WENT_WRONG: "Something went wrong",
  SESSION_TIMEOUT: "Session Timeout!",
  SOMETHING_WENT_WRONG_DESCRIPTION:
    "Sorry, we’re experiencing an issue while processing your request. Please try again."
};

export const MESSAGE = {
  CANNOT_FIND_PLACE: "Cannot find place",
  CONFIRMATION_LEAVE:
    "Are you sure you want to leave? Any unsaved changes will be lost.",
  CONFIRMATION_RESET:
    "This will remove all datasets and settings. You’ll have to start a new analysis to continue.",
  SAVING_YOUR_DATASET: "Please wait while your dataset is being saved.",
  SAVED_YOUR_DATASET_FAILED:
    "Sorry, we couldn’t save your dataset. Please try again.",
  OPEN_PROJECT_SUCCESS: "Configuration successfully loaded.",
  SAVING_NEW_PROJECT: "Please wait while your configuration is being saved.",
  LOADING_CONFIGURATION:
    "Please wait while your configuration is being loaded.",
  LOADING_CONFIGURATION_FAILED:
    "Sorry, we couldn’t load your configuration. Please try again.",
  LOADING_SPATIAL_ANALYSIS: "Spatial Analysis in Progress",
  PREPARE_TABULAR_DATA_AND_MAPVIEW:
    "Preparing the tabular data and map view for your spatial analysis. This may take some time.",
  LOADING_SPATIAL_ANALYSIS_FAILED:
    "Sorry, we couldn’t load the spatial analysis. Please try again.",
  LOADING_ADMIN_AREA_DATA: "Loading administrative area data...",
  DELETE_DATASET_FAILED:
    "Sorry, we couldn't delete the dataset. Please try again.",
  LOADING: "Loading...",
  DATASET_MANAGEMENT_UNPUBLISH_DATASET_CONFIRMATION_DESCRIPTION:
    "This dataset might be used in one or more analyses. Unpublishing it may impact those analyses. You can still edit the dataset after unpublishing.",
  DATASET_MANAGEMENT_PUBLISH_DATASET_CONFIRMATION_DESCRIPTION:
    "Once published, datasets will be available for spatial analysis.",
  DATASET_REPLACE_ALL_SUCCESS: "All data has been successfully replaced.",
  DATASET_ADD_MORE_SUCCESS: "Data has been successfully added.",
  DATASET_DELETE_SUCCESS: "Dataset has been deleted permanently.",
  DATASET_ADD_LOADING: "Please wait while dataset is being loaded.",
  DATASET_ADD_TITLE_SUCCESS: "Dataset Loaded Successfully",
  DATASET_ADD_DESCRIPTION_PREFIX: "The dataset",
  DATASET_ADD_DESCRIPTION_SUCCESS:
    "is now ready for analysis and use on the platform.",
  DATASET_ADD_TITLE_FAILED: "Dataset Failed to Load",
  DATASET_ADD_DESCRIPTION_FAILED:
    "failed to load. Please check the dataset and try again.",
  DATASET_DELETE_FAILED:
    "Sorry, we couldn’t delete the dataset. Please try again.",
  SAVE_DATA_SETTING_SUCCESS:
    "Country and Spatial Aggregation successfully added.",
  GEOMETRIC_VALUE_ADDED_SUCCESS:
    "Geometric value has been added as a new attribute.",
  CONFIRM_LOG_OUT: "You will need to sign in again to access your account.",
  UNPUBLISH_DATASET_SUCCESS: "Your dataset has been unpublished.",
  PUBLISH_DATASET_SUCCESS: "Your dataset has been published.",
  UNPUBLISH_DATASET_FAILED:
    "Sorry, we couldn’t unpublish the dataset. Please try again.",
  PUBLISH_DATASET_FAILED:
    "Sorry, we couldn’t publish the dataset. Please try again.",
  SETTING_ADD_USER_EMAIL_INVALID:
    "The email address you entered is invalid. Please check the format and try again.",
  SETTING_ADD_USER_EMAIL_ALREADY_EXISTS:
    "This email belongs to an existing user. Use a different email to continue.",
  SETTING_SAVE_USER_TITLE_SUCCESS: "User Successfully Created",
  SETTING_SAVE_USER_DESCRIPTION_SUCCESS: "User has been created successfully.",
  SETTING_SAVE_USER_TITLE_FAILED: "Something Went Wrong",
  SETTING_SAVE_USER_DESCRIPTION_FAILED:
    "We're experiencing an issue processing your request. Please try again.",
  SETTING_SAVE_USER_TITLE_CLOSE: "Unsaved Changes",
  SETTING_SAVE_USER_DESCRIPTION_CLOSE:
    "Are you sure you want to leave? Any unsaved changes will be lost.",
  ANALYSIS_SAVE_AS_USER_DATASET_SUCCESS: "Dataset has been successfully saved.",
  DATA_SETTING_SAVED: "Data Setting Saved",
  DELETE_GROUP_MANAGEMENT_TITLE_SUCCESS_CONFIRMATION: "Delete This Group?",
  DELETE_GROUP_MANAGEMENT_DESCRIPTION_CONFIRMATION_SUFFIX:
    "will permanently remove all associated data. This action cannot be undone.",
  DELETE_GROUP_MANAGEMENT_DESCRIPTION_CONFIRMATION_PREFIX: "Deleting",
  DELETE_GROUP_MANAGEMENT_TITLE_SUCCESS: "Group Deleted Successfully",
  DELETE_GROUP_MANAGEMENT_DESCRIPTION_SUCCESS:
    "You've successfully removed the group.",
  DELETE_GROUP_MANAGEMENT_TITLE_FAILED: "Group Deletion Failed",
  DELETE_GROUP_MANAGEMENT_DESCRIPTION_FAILED:
    "Sorry, something went wrong. Please remove all users bound to this group and try again.",
  SETTING_WEIGHT_VALUES_INVALID: "At least one weight must be greater than 0.",
  ADD_GROUP_PANEL_TITLE_SUCCESS: "Group Successfully Created",
  ADD_GROUP_PANEL_DESCRIPTION_SUCCESS:
    "You can now assign users and manage this group.",
  ADD_GROUP_PANEL_TITLE_DUPLICATE_ERROR: "Group Name Taken",
  ADD_GROUP_PANEL_DESCRIPTION_PREFIX_DUPLICATE_ERROR: "The name",
  ADD_GROUP_PANEL_DESCRIPTION_SUFFIX_DUPLICATE_ERROR:
    "is already in use. Please enter a different name for this group.",
  EDIT_GROUP_PANEL_TITLE_SUCCESS: "Group Updated",
  EDIT_GROUP_PANEL_DESCRIPTION_SUCCESS:
    "We've updated the information and permissions.",
  EDIT_GROUP_PANEL_TITLE_FAILED: "Something Went Wrong",
  EDIT_GROUP_PANEL_DESCRIPTION_FAILED:
    "Sorry, we're experiencing an issue processing your request. Please try again.",
  CATCHMENT_CONTOUR_INVALID:
    "Can’t generate catchment area. Please try another value.",
  CATCHMENT_CONTOUR_INVALID_DURATION:
    "Duration cannot be more than 60 minutes.",
  CATCHMENT_CONTOUR_INVALID_DISTANCE:
    "Distance cannot be more than 100,000 meters (100 km).",
  ANALYSIS_SUMMARY: {
    GENERATING_SUMMARY: "Generating summary, please wait...",
    GENERATING_SUMMARY_FAILED:
      "Sorry, something went wrong while processing the summary. Please try again.",
    NO_DATA_ANALYSIS_SUMMARY_DATASET:
      "No data available to display. Please check your data or try adjusting the configuration menu."
  },
  COULD_NOT_FIND_LOCATION: "Sorry, we couldn’t find the location.",
  DATASET_UPLOAD_SUCCESS_TITLE: "Dataset Uploaded Successfully",
  DATASET_UPLOAD_SUCCESS_DESCRIPTION:
    "Your data is now available for analysis.",
  DATASET_UPLOAD_SUCCESS_WITH_WARNING_TITLE:
    "Upload Successful (with Warnings)",
  DATASET_UPLOAD_ERROR_TITLE: "Failed to Add Data",
  DATASET_UPLOAD_ERROR_DESCRIPTION:
    "All data in your dataset already exists. Please review your dataset and try again.",
  DATASET_UPLOAD_ADD_MORE_DUPLICATE_DESCRIPTION:
    "Your data is added and ready for analysis. Some data in your dataset are duplicates of existing data.",
  LEAVE_ANALYSIS_CONFIRMATION_TITLE: "Leave Analysis Summary?",
  LEAVE_ANALYSIS_CONFIRMATION_DESCRIPTION:
    "Are you sure you want to leave? If you continue, your current view will be cleared.",
  UNSAVED_CHANGES_TITLE: "Unsaved Changes",
  ANALYSIS_SUMMARY_DATA_BAR_CHART_LIMIT_10:
    "Only the top 10 data entries are displayed.",
  ANALYSIS_SUMMARY_SUMMARY_DATA_TABLE_LIMIT_INFO_10:
    "This table displays up to 10 entries only.",
  DATASET_UPLOAD_ERROR_FILE_TOO_LARGE_TITLE: "File Too Large",
  DATASET_UPLOAD_ERROR_FILE_TOO_LARGE_DESCRIPTION:
    "The file you tried to upload exceeds the 100MB limit. Please upload a smaller file.",
  DATASET_UPLOAD_ERROR_FILE_NOT_SUPPORTED_TITLE: "Unsupported File Format",
  DATASET_UPLOAD_ERROR_FILE_NOT_SUPPORTED_DESCRIPTION: (
    fileTypesText: string
  ) =>
    `Only ${fileTypesText} files are supported. Please upload one of these formats.`,
  NO_INTERNET_CONNECTION_TITLE: "No Internet Connection",
  NO_INTERNET_CONNECTION_DESCRIPTION:
    "Please check your connection and try again.",
  CHANGE_PASSWORD_SUCCESS_TITLE: "Password Changed Successfully",
  CHANGE_PASSWORD_SUCCESS_DESCRIPTION:
    "You're logged in and ready to continue.",
  CHANGE_PASSWORD_INCORRECT_PASSWORD_TITLE: "Incorrect Password",
  CHANGE_PASSWORD_INCORRECT_PASSWORD_DESCRIPTION:
    "The current password you entered is wrong. Please check and try again.",
  CHANGE_PASSWORD_GENERAL_ERROR_TITLE: "Something Went Wrong",
  CHANGE_PASSWORD_GENERAL_ERROR_DESCRIPTION:
    "Sorry, we're experiencing an issue processing your request. Please try again.",
  AGGREGATION_INFO_TOOLTIP:
    "Data is averaged to reflect general mobility patterns based on date and time range.",
  LOADING_GENERAL: "Please wait while we prepare your request.",
  SUCCESS_GENERAL: "Your request was successful.",
  ERROR_GENERAL: "Something went wrong. Please try again.",
  NO_GEOM_ADMIN_AREA:
    "Please select one attribute to get the value of the Administrative Area.",
  NO_GEOM_POINT_GEOCODING:
    "Please select one attribute for geocoding to get the value of the Point.",
  CANCEL_INPROGRESS_ANALYSIS_CONFIRMATION:
    "Are you sure you want to leave? If you do, the current analysis will stop immediately.",
  CANCEL_INWAITING_ANALYSIS_CONFIRMATION:
    "Are you sure you want to cancel this analysis? If you continue, it will be removed from the queue.",
  ANALYSIS_EXPIRED:
    "This analysis has expired. You need to regenerate it to view the report.",
  SETTING_DELETE_USER_TITLE_SUCCESS: "User Deleted Successfully",
  SETTING_DELETE_USER_DESCRIPTION_SUCCESS:
    "We have removed all associated data.",
  SETTING_DELETE_USER_TITLE_FAILED: "Something Went Wrong",
  SETTING_DELETE_USER_DESCRIPTION_FAILED:
    "Sorry, we're experiencing an issue processing your request. Please try again.",
  MULTIPLE_SEARCH_WITH_SELECT_INFO:
    "Add attributes as filters to narrow down your data.",
  MAP_VIEW_ACTION_COLUMN_FAILED:
    "The geometry is invalid and cannot be rendered, please double check the geometry value.",
  DELETE_DATASET_MANAGEMENT_ROWS_CONFIRMATION_TITLE:
    "Are you sure you want to delete?",
  DELETE_DATASET_MANAGEMENT_ROWS_CONFIRMATION_DESCRIPTION:
    "This action can’t be undone and may affect future data uploads.",
  DOWNLOAD_PDF_AI_SUMMARY_NOT_COMPLETE:
    "The AI summary isn't fully loaded yet. You can still download now, but the summary may be missing in the PDF.",
  DOWNLOAD_PDF_CHARTS_LOADING:
    "Please wait — charts are still loading. PDF will be available once all charts are ready.",
  SPATIAL_ANALYSIS_SUCCESS_TITLE: "Spatial Analysis Completed",
  SPATIAL_ANALYSIS_SUCCESS_DESCRIPTION:
    "Your tabular data and map view are ready. You can now explore the results.",
  SPATIAL_ANALYSIS_NO_DATA_AVAILABLE: "No Data Available",
  SPATIAL_ANALYSIS_SCORE_GENERATION_FAILED: "Score Generation Failed",
  ANALYSIS_HISTORY_SITE_PROFILING_NO_DATA:
    "Output area follows the boundaries of your selected area or sites.",
  SESSION_EXPIRED_TITLE: "You’ve Been Logged Out",
  SESSION_EXPIRED_DESCRIPTION:
    "Your current session has ended. Please log in again to continue.",
  DATASET_CONFIRMATION_CHANGE_GLOBAL_FILTER:
    "Would you like to set this dataset’s boundaries as the filter area for all datasets?",
  DATASET_ADMIN_AREA_POI_DESCRIPTION:
    "Set the location where the POIs will appear.",
  DATASET_ENABLED_DEFINE_ANOTHER_AREA_INPUT:
    "Enable to define another area input",
  SPATIAL_ANALYSIS_SCORE_NOT_AVAILABLE_TITLE: "Score Not Available",
  SPATIAL_ANALYSIS_SCORE_NOT_AVAILABLE_DESCRIPTION:
    "Analysis completed, but a normalized score requires comparing multiple values. Since only one area was selected, there is nothing to compare against. Try switching to grid analysis or selecting an area with multiple units.",
  REPORT_SUMMARY_NO_SCORES_AVAILABLE_TITLE: "No scores available to summarize",
  REPORT_SUMMARY_NO_SCORES_AVAILABLE_DESCRIPTION:
    "We couldn't find any score values to analyze. The summary will be generated once you have scores available.",
  AI_SUMMARY_NO_SCORES_AVAILABLE_TITLE: "No scores available to summarize",
  AI_SUMMARY_NO_SCORES_AVAILABLE_DESCRIPTION:
    "The AI Summary generates insights by evaluating how the  area performs against others based on score. To provide a meaningful summary, the system requires a baseline derived from multiple data points.",
  TIMESERIES_PANEL_VIEW_DATA_DESCRIPTION:
    "By default, the timeline shows the aggregated value for all areas. Select a specific area on the map to view its individual timeline.",
  UNLOCK_AI_POPOVER_TITLE: "Unlock AI Analysis",
  UNLOCK_AI_CONTENT_POPOVER_DESCRIPTION:
    "This feature is available for accounts with AI access.",
  UNLOCK_AI_CONTENT_POPOVER_DESCRIPTION_CONTENT:
    "Please contact the Bvarta sales team to activate AI Analysis for your LOKASI Intelligence workspace",
  UNLOCK_AI_SUMMARY_TITLE: "AI Summary is Not Available",
  UNLOCK_AI_SUMMARY_CONTENT:
    "This feature is available for accounts with AI access. Contact Bvarta sales team to activate AI Summary for your workspace",
  AI_SUMMARY_FEEDBACK: {
    SAVE_FAILED: "Failed to save feedback. Please try again.",
    THANKS_FOR_FEEDBACK: "Thank you for your feedback",
    THANKS_FOR_FEEDBACK_OTHER: "Thanks! Your feedback helps us improve.",
    COPIED_TO_CLIPBOARD: "Copied to clipboard",
    COPY_FAILED: "Failed to copy summary",
    COPY_TOOLTIP: "Copy",
    GOOD_RESPONSE: "Good response",
    BAD_RESPONSE: "Bad response",
    DISLIKE_POPUP: {
      TITLE: "What didn’t you like about this response (optional)?",
      BACK_TO_OPTIONS: "Back to options",
      CLOSE: "Close feedback",
      PLACEHOLDER: "Add specific details",
      SUBMIT: "Submit feedback",
      OPTION_MISLEADING: "Misleading",
      OPTION_INCOMPLETE: "Incomplete",
      OPTION_IRRELEVANT: "Irrelevant",
      OPTION_UNCLEAR: "Unclear"
    }
  },
  DATASET_CONFIRMATION_APPLY_LABEL_FROM_GLOBAL_FILTER: "Yes, apply to all",
  DATASET_CONFIRMATION_KEEP_LABEL_FROM_GLOBAL_FILTER: "No, keep default only",
  DATASET_CONFIRMATION_UPDATE_FROM_GLOBAL_FILTER:
    "You've updated the area filter. Datasets with custom filters won't be affected. Apply changes to all datasets?",
  SHAPEFILE_NOTE:
    "Upload a ZIP or individual files containing all required Shapefile components (.shp, .dbf, and .shx) - all files must share the same base name.",
  SHAPEFILE_ERROR_UNSUPPORTED_MULTIPLE_TITLE: "Cannot Upload Files",
  SHAPEFILE_ERROR_UNSUPPORTED_MULTIPLE_DESCRIPTION:
    "Multiple file upload is only supported for shapefiles",
  SHAPEFILE_ERROR_NOT_SUPPORTED_MULTIPLE_ONETIME_TITLE:
    "Not Support Multiple Shapefile",
  SHAPEFILE_ERROR_NOT_SUPPORTED_MULTIPLE_ONETIME_DESCRIPTION:
    "Multiple Shapefile sets detected. Please upload one set at a time.",
  SHAPEFILE_ERROR_SAMENAME_TITLE: "Files Must Have the Same Name",
  SHAPEFILE_ERROR_SAMENAME_DESCRIPTION:
    "All files must be the same name. Please double check.",
  UPLOAD_DIALOG_DESCRIPTION:
    "Upload your own datasets to be used for analysis or visualization purposes.",
  DATASET_WIDGET_NO_SUPPORTED_DATASET_DESCRIPTION:
    "We did not find any supported datasets for chart.",
  SERVICE_UNAVAILABLE: "Service temporarily unavailable. Please try again.",
  WIDGET_SUCCESS_ADDED_TITLE: "New Widget has been added",
  WIDGET_SUCCESS_ADDED_DESCRIPTION:
    "Your widget has been successfully added to the dashboard.",
  WIDGET_FAILED_TO_PREVIEW_DESCRIPTION:
    "Unable to load preview. Please try again",
  WIDGET_FAILED_TO_ADD_DESCRIPTION: "Unable to save widget. Please try again"
};

export const EMPTY_STATE_ANALYSIS_HISTORY = {
  LIST: {
    SEARCH_NOT_FOUND: {
      title: "No Results Found",
      desc: "Sorry, we couldn’t find any matches from your keyword. Try using different keyword."
    },
    FILTER_NOT_FOUND: {
      title: "No Results Found",
      desc: "Sorry, no results match your selected filters. Try adjusting the filter options."
    },
    EMPTY_LIST: {
      title: "No Historical Analysis Found",
      desc: "Your past analyses will appear here once you’ve generated one."
    }
  },

  DETAIL: {
    HAVE_LIST_NOT_SELECTED: {
      title: "Select an Analysis to View Details",
      desc: "Select an analysis from the list to view its detailed parameters configuration."
    },
    EMPTY_LIST: {
      title: "No Analysis Details Available",
      desc: "Select an analysis from the list to view its detailed parameters configuration."
    }
  }
};
